import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { customToast } from 'core-lib/utils/customToast';
import { getDefaultHeaders } from 'core-lib/utils/network';
import { setImageUrl } from 'shop/utils/helper';
import {
  DropDownContentType,
  ProductDescription,
  VariantsType,
} from '../../types/product';
import { getImagesFromObjectArrays } from '../../utils';
import { serializeHomePage, serializeProduct } from '../home/getHomepage';

const getTableValues = (data) => {
  const array = [];
  if (!data) return array;
  Object.keys(data)?.forEach((element) => {
    array.push({
      label: element,
      value: data[element],
    });
  });
  return array;
};
const getProductSummaries = (data) => {
  const array = data?.map((item) => ({
    title: item?.title,
    content: item?.value,
    contentType: item?.type ?? DropDownContentType.TEXT,
    data: getTableValues(item?.value),
  }));
  return array;
};

const getVariants = (data): VariantsType[] => {
  return data?.map((obj) => ({
    label: obj?.label,
    options: obj?.options?.map((item) => ({
      isDefault: item?.is_default,
      option: item?.option,
      uiType: item?.ui_type,
      value: item?.value ? setImageUrl(item?.value, 1) : null,
    })),
  }));
};

const serializeData = (data, configurableProduct, similarProducts, isGift) => {
  const obj: ProductDescription = {
    ...serializeProduct(data),
    descriptionImages: getImagesFromObjectArrays(data?.description_images),
    productHighlights: data?.product_highlights,
    productSummaries: getProductSummaries(data?.product_summaries),
    expiry: data?.expiry,
    mlSavings: data?.ml_savings,
    mlUsed: data?.ml_used,
    coverImageNudge: data?.cover_image_nudge,
    priceNudge: data?.price_nudge,
    pickUpPostCode : data?.pincode,
    video: data?.video_url?.url
      ? {
          url: data?.video_url?.url,
          thumbnail: data?.video_url?.thumbnail,
        }
      : null,

    configuration: configurableProduct?.child_products
      ? {
          childProductId: configurableProduct?.child_products,
          variants: getVariants(configurableProduct?.variants),
        }
      : null,

    similarProducts: serializeHomePage(similarProducts),
    isGift: !!isGift,
    genericInfo:
      data?.generic_info?.length > 0
        ? data.generic_info.map((item) => ({
            icon: item?.icon,
            text: item?.text,
          }))
        : null,
  };

  return obj;
};
const getProductDescription = async (productId: number) => {
  const endPoint = `${apiConfig(
    'magento'
  )}/default/V1/products/productId/customer/${productId}`;

  const { response, error }: any = await getMethod({
    endPoint,
    headers: getDefaultHeaders({ deviceId: true }),
  });

  if (response) {
    return serializeData(
      response?.data?.details,
      response?.data?.configurable_product,
      response?.data?.similar_products,
      response?.data?.is_gift
    );
  } else if (error) {
    customToast({
      label: error?.message || 'Something went wrong',
      variant: 'criticalNotPriority',
    });
  }
  return null;
};

export default getProductDescription;
